import { FiChevronLeft } from "react-icons/fi";
import { useNavigate } from "react-router-dom";

const TermsAndCondition = () => {
  const navigate = useNavigate();

  return (
    <div style={{ padding: "20px", color: "#A6A7A8" }}>
      <div style={{ display: "flex", alignItems: "center", marginTop: "30px" }}>
        <button className="back-button" onClick={() => navigate("/home")}>
          <FiChevronLeft className="back-button-icon" />
        </button>
        <div
          style={{
            color: "#FFFFFF",
            fontSize: "18px",
            fontWeight: 700,
            marginLeft: "20px",
          }}
        >
          FAQ
        </div>
      </div>
      <div>
        <ul className="mt-4">
          <li>
            <p className="FAQ-Question">What is the Bitcoin Premier League?</p>
            <p className="paragraph">
              The Bitcoin Premier League 2026 is a seasonal rewards event
              running from 28th March to 31st May 2026, featuring Match
              Predictions, Powerplay Rush offers, Weekly Streaks, a Highest
              Stacker leaderboard and 5% rewards on Elite Card spends — all
              designed to help you earn more Sats, SuperCoins, and Gold rewards.
            </p>
          </li>
          <li>
            <p className="FAQ-Question">
              What happens if the match ends in a tie?
            </p>
            <p className="paragraph">
              In the event of a tie, all predictions are deemed null and void
              and no rewards are distributed.
            </p>
          </li>
          <li>
            <p className="FAQ-Question">Who can participate in the campaign?</p>
            <p className="paragraph">
              All users with an active GoSats account can participate. Rewards
              and features vary based on your user tier — Elite, Intro Card
              (Physical & Virtual), or Non-Card.
            </p>
          </li>
          <li>
            <p className="FAQ-Question">What is the Predict & Win?</p>
            <p className="paragraph">
              Predict & Win is a prediction game where you pick the winning IPL
              team before a match starts. A correct prediction unlocks one of
              several exciting rewards.
            </p>
          </li>
          <li>
            <p className="FAQ-Question">When can I make my match prediction?</p>
            <p className="paragraph">
              Predictions can be made up to 12 hours before the match starts.
              Once the match begins, predictions are no longer accepted.
            </p>
          </li>
          <li>
            <p className="FAQ-Question">
              How long are prediction rewards valid?
            </p>
            <p className="paragraph">
              The 50% extra rewards are valid for the next 12 hours. Other
              rewards have specific redemption windows tied to the reward type —
              please check your reward details after claiming.
            </p>
          </li>
          <li>
            <p className="FAQ-Question">
              50% Extra Reward is valid on which categories?
            </p>
            <p className="paragraph">
              The 50% extra rewards are valid on Food, Fashion, and Travel
              categories.
            </p>
          </li>
          <li>
            <p className="FAQ-Question">
              What happens to my Predict & Win unclaimed rewards if I miss the
              redemption window?
            </p>
            <p className="paragraph">
              Rewards must be claimed within 12 hours of being unlocked for
              Predict & Win. If the window is missed, the reward expires and
              cannot be reclaimed.
            </p>
          </li>
          <li>
            <p className="FAQ-Question">What is the Powerplay Rush?</p>
            <p className="paragraph">
              Powerplay Rush is a limited-time offer active during Overs 1–6 of
              every IPL match. During this window, you can enjoy special
              discounts on Food, Travel, and E-commerce vouchers.
            </p>
          </li>
          <li>
            <p className="FAQ-Question">What is the Weekly Streak?</p>
            <p className="paragraph">
              The Weekly Streak rewards you for making consistent transactions
              of ₹200 or more — via vouchers, gold one-time investments, or card
              spends — for 7 consecutive days. Complete the streak to claim a
              reward at the end of the 7 days.
            </p>
          </li>
          <li>
            <p className="FAQ-Question">
              What happens if I miss a day in my streak?
            </p>
            <p className="paragraph">
              Your streak resets if you miss even one day. You’ll need to start
              a fresh streak from the next day.
            </p>
          </li>
          <li>
            <p className="FAQ-Question">
              What happens if a transaction contributing to my streak is
              refunded?
            </p>
            <p className="paragraph">
              If any transaction that counted toward your streak is refunded,
              your streak is voided and you'll need to start a new one.
            </p>
          </li>
          <li>
            <p className="FAQ-Question">
              What happens to my Weekly Streak unclaimed rewards if I miss the
              redemption window?
            </p>
            <p className="paragraph">
              Streak rewards must be claimed within 24 hours of being unlocked.
              If the window is missed, the reward expires and cannot be
              reclaimed.
            </p>
          </li>
          <li>
            <p className="FAQ-Question">What is Highest Stacker Kaun?</p>
            <p className="paragraph">
              Highest Stacker Kaun is a leaderboard contest with a prize pool of
              2,50,000 Sats. The top 100 users are ranked by the total value of
              rewards earned during the IPL season.
            </p>
          </li>
          <li>
            <p className="FAQ-Question">
              Which rewards are counted towards Highest Stacker Kaun?
            </p>
            <p className="paragraph">
              Rewards earned from Card Spends and Voucher Purchases are counted
              towards Highest Stacker Kaun. Additionally, 2% of the value of
              one-time gold investments is considered for the leaderboard.
            </p>
          </li>
          <li>
            <p className="FAQ-Question">
              How are the 2,50,000 Sats distributed among winners?
            </p>
            <p className="paragraph">
              The Sats pool is distributed on a weighted basis among the Top 100
              users, meaning higher-ranked users receive a larger share.
            </p>
          </li>
          <li>
            <p className="FAQ-Question">
              Are there any transaction categories that are blocked/ineligible
              across the campaign?
            </p>
            <p className="paragraph">
              Yes. Transactions in the following categories are not eligible for
              Match Prediction rewards, Weekly Streaks and the Highest Stacker
              leaderboard: Fastag Recharge, Indian Railways, Travel Agencies,
              Tour Operators, Bill/Utility Payments, Digital Wallet Loads, Real
              Estate, Government Services, Telecommunications,
              Gift/Novelty/Souvenir Shops, Insurance, Quasi Cash, Fuel,
              Rent/Education, Toll/Bridge, Discount Stores — unless explicitly
              stated in your unlocked reward.
            </p>
          </li>
          <li>
            <p className="FAQ-Question">
              What is the 5% rewards campaign on Elite Card spends?
            </p>
            <p className="paragraph">
              Users earn 5% rewards on every eligible Elite card spend.
            </p>
          </li>
          <li>
            <p className="FAQ-Question">
              What is the reward structure of the 5% rewards?
            </p>
            <p className="paragraph">
              1% rewards are withdrawable on the Bitcoin blockchain.
            </p>
            <p className="paragraph">
              4% rewards can be used for redemptions within the GoSats app.
            </p>
          </li>
          <li>
            <p className="FAQ-Question">
              Are there any ineligible transaction categories for the 5% rewards
              on Elite Card spends?
            </p>
            <p className="paragraph">
              Yes, transactions in Fastag Recharge, Indian Railways, Travel
              Agencies, Tour Operators, Bill/Utility Payments, Digital Wallet
              Loads, Real Estate, Government Services, Telecommunications,
              Gift/Novelty/Souvenir Shops, Insurance, Quasi Cash, Fuel,
              Rent/Education, Toll/Bridge, Discount Stores, and card spends on
              Voucher Purchases, SatsPay, BBPS, and Gold Investments are
              excluded.
            </p>
          </li>
          <li>
            <p className="FAQ-Question">What if I don’t receive my rewards?</p>
            <p className="paragraph">
              Please contact in-app support or write to support@gosats.io from
              your registered email ID.
            </p>
          </li>
        </ul>
      </div>
    </div>
  );
};

export default TermsAndCondition;
